var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15850_1369)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 206,
    rx: 16,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.621 96.7094L110.235 87.4344L113.327 84.3427C114.174 83.4962 115.214 83.0729 116.447 83.0729C117.68 83.0729 118.719 83.4962 119.566 84.3427L122.657 87.4344C123.504 88.2809 123.945 89.3026 123.982 90.4995C124.019 91.695 123.614 92.716 122.768 93.5625L119.621 96.7094ZM116.419 99.9667L93.0104 123.375H83.625V113.99L107.033 90.5812L116.419 99.9667Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15850_1369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 206,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUpload);
export default __webpack_public_path__ + "static/media/default-upload.1aaaa0e44f474789971e8ab1f24a3b60.svg";
export { ForwardRef as ReactComponent };